<template>
  <div class="center">
    <div style="display: flex; align-items: center; margin: 20px 0">
      <el-input
        style="width: 220px; margin-right: 10px"
        placeholder="请输入企业关键字"
        prefix-icon="el-icon-search"
        clearable
        v-model="queryParams.name"
      >
      </el-input>
      <el-date-picker
        style="margin-right: 10px"
        v-model="queryParams.createTimeStart"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="date"
        placeholder="开始日期"
      >
      </el-date-picker>
      <el-date-picker
        style="margin-right: 10px"
        v-model="queryParams.createTimeEnd"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="结束日期"
      >
      </el-date-picker>
      <el-button type="primary" icon="el-icon-search" @click="handleQuery"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="purchaseList"
      style="width: 100%"
      fit
      v-loading="loading"
      @row-click="rowClick"
    >
      <el-table-column
        prop="name"
        label="企业名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column label="入驻时间" width="300" align="center">
        <template slot-scope="{ row }">
          <span>{{ parseTime(row.createTime, "{y}-{m}-{d}") }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
        :autoScroll="false"
      />
    </div>
  </div>
</template>
  
<script>
import {
  getNoticeList,
  getPurchaseList,
  getSupplierList,
  getRNoticeList,
} from "@/api/home";
export default {
  name: "qiye",
  data() {
    return {
      loading: false,
      options: [
        {
          label: "未成交",
          value: "0",
        },
        {
          label: "已成交",
          value: "1",
        },
        {
          label: "已作废",
          value: "2",
        },
      ],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: "",
        createTimeStart: "",
        createTimeEnd: "",
      },
      purchaseList: [],
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    rowClick(row) {
      // window.open("/#/rdetails?id=" + row.id, "采购公告");
    },
    getList() {
      this.loading = true;
      // if (this.queryParams.createTimeEnd) {
      //   this.queryParams.createTimeEnd =
      //     this.queryParams.createTimeEnd + " 23:59:59";
      // }
      if (this.queryParams.createTimeEnd) {
        if (this.queryParams.createTimeEnd.indexOf("23:59:59") > -1) {
        } else {
          this.queryParams.createTimeEnd =
            this.queryParams.createTimeEnd + " 23:59:59";
        }
      }
      getSupplierList(this.queryParams).then((res) => {
        this.purchaseList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
  },
};
</script>

  